import { TaxSettingsData } from "@/typings/taxability";
import { TaxExemptionImage } from "./taxExemptionImage";

export class Address {
  // The first item in the emails / phones is the primary
  emails: {
    id: any;
    email_address: string;
    label: string | null;
  }[] = [];
  phones: {
    id: any;
    phone_number: string;
    label: string | null;
    type: string;
  }[] = [];
  receives_communication = false;
  id: any = null;
  owner_id = 0; // customer id
  owner_type = "";
  street = "";
  unit = "";
  city = "";
  state = "";
  zip_code = "";
  time_zone = "";
  primary = false;
  name = "";
  external_ref = null;
  location_type = "";
  commercial_property = false;
  invalid = false;
  manual_entry = false;
  latitude = 0;
  longitude = 0;
  tax_exempt = false;
  tax_exemption_image?: TaxExemptionImage = undefined;
  pinned = false;
  gid: string; // global id - used for tax override updates
  tax_setting: TaxSettingsData | null = null;
  links?: {
    job_create?: string;
    equipment_create?: string;
  } = undefined;

  constructor(params: Partial<Address> = {}) {
    Object.assign(this, params);
    if (params.phones) this.phones = params.phones.slice(0);
    if (params.emails) this.emails = params.emails.slice(0);
  }
}
